export default {"src":"/_next/static/media/Logo_Animation2.8e36a8c2.gif","height":558,"width":553,"blurWidth":0,"blurHeight":0};